/** Default birthday for new members: today − 18 years, as YYYY-MM-DD. */
export function defaultDateOfBirth(): string {
  const d = new Date()
  d.setFullYear(d.getFullYear() - 18)
  return d.toISOString().slice(0, 10)
}
